export default "__VITE_ASSET__kDo46Iwe__"